// removed by extract-text-webpack-plugin
module.exports = {"createGoalFormContainer":"createGoalFormContainer-zJolr","goalDescription":"goalDescription-2CL7Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/create/_createGoalForm.css
// module id = 1199
// module chunks = 1